export default "__VITE_ASSET__C0FTM1U2__"